import type { NotificationSettings } from '../hooks/use-notification';

export type NotificationTypeSetting = {
  type: string;
  label: string;
  description: string;
  field: keyof Omit<NotificationSettings, 'emailNotificationsEnabled'>;
};

export const NOTIFICATION_TYPE_SETTINGS: NotificationTypeSetting[] = [
  {
    type: 'course_published',
    label: 'Course published',
    description: 'Email users when a course they can see is published.',
    field: 'coursePublishedEmailEnabled',
  },
  {
    type: 'leaderboard_drop',
    label: 'Leaderboard drop',
    description: 'Email a user when they fall down the leaderboard.',
    field: 'leaderboardDropEmailEnabled',
  },
  {
    type: 'test_reminder',
    label: 'Test reminder',
    description:
      'Email a user when they are behind on the tests required for the period.',
    field: 'testReminderEmailEnabled',
  },
];
